import { PipeTransform } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var RecurrenceDescriptionHumanizerPipe = /** @class */ (function () {
    function RecurrenceDescriptionHumanizerPipe(fuseTranslationLoaderService, translateService) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.translateService = translateService;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    RecurrenceDescriptionHumanizerPipe.prototype.transform = function (recurrenceRepeat) {
        var from = recurrenceRepeat.from
            ? moment(recurrenceRepeat.from).format('DD/MM/YYYY')
            : '00/00/0000';
        var until = recurrenceRepeat.until
            ? this.translateService.instant('RECURRENCE.END_DATE_AT', { until: moment(recurrenceRepeat.until).format('DD/MM/YYYY') })
            : this.translateService.instant('RECURRENCE.WITHOUT_END_DATE');
        var every = recurrenceRepeat.every || 0;
        var interval = this.intervalDescription(recurrenceRepeat);
        var skipWeekend = recurrenceRepeat.skipWeekend && recurrenceRepeat.interval !== 'weekly'
            ? this.translateService.instant('RECURRENCE.DESCRIPTION_SKIP_WEEKEND')
            : '';
        var interpolateParams = {
            from: from,
            until: until,
            every: every,
            interval: interval,
            skipWeekend: skipWeekend
        };
        return this.translateService.instant('RECURRENCE.EXPLANATION', interpolateParams)
            .replaceAll(/\s\s+/g, ' ')
            .replaceAll(/\s\./g, '.');
    };
    RecurrenceDescriptionHumanizerPipe.prototype.intervalDescription = function (recurrenceRepeat) {
        switch (recurrenceRepeat.interval) {
            case 'monthly':
                var dayOfMonth = recurrenceRepeat.dayOfMonth || 0;
                return this.translateService.instant('RECURRENCE.DESCRIPTION_MONTHS', {
                    dayOfMonth: dayOfMonth
                });
            case 'weekly':
                var weekdayUpperCased = (recurrenceRepeat.weekday || 'monday').toUpperCase();
                var weekday = this.translateService.instant("RECURRENCE.WEEKDAY." + weekdayUpperCased);
                return this.translateService.instant('RECURRENCE.DESCRIPTION_WEEKS', {
                    weekday: weekday
                });
            case 'daily':
            default:
                return this.translateService.instant('RECURRENCE.DESCRIPTION_DAYS');
        }
    };
    return RecurrenceDescriptionHumanizerPipe;
}());
export { RecurrenceDescriptionHumanizerPipe };
